export const LANGUAGE_TO_LOCALE = {
  English: 'en',
  Hindi: 'hi',
  Kannada: 'kn',
  Tamil: 'ta',
  Telugu: 'te',
  Bengali: 'bn',
  Marathi: 'mr',
  Malayalam: 'ml',
  Gujarati: 'gu',
  Punjabi: 'pa',
  Urdu: 'ur',
  Odia: 'or',
  Sanskrit: 'sa',
  Spanish: 'es',
  French: 'fr',
  German: 'de',
  Arabic: 'ar'
};

function getGoogTransCookieVariants() {
  const isSecure = typeof window !== 'undefined' && window.location?.protocol === 'https:';
  const base = `path=/; SameSite=Lax${isSecure ? '; Secure' : ''}`;
  const variants = new Set([base]);

  try {
    const hostname = window.location.hostname;
    if (hostname && hostname !== 'localhost' && hostname !== '127.0.0.1') {
      const parts = hostname.split('.').filter(Boolean);

      // Current host + dot-prefixed host
      variants.add(`${base}; domain=${hostname}`);
      variants.add(`${base}; domain=.${hostname}`);

      // Parent domains (e.g. ubsaapp.testatozas.in -> testatozas.in)
      for (let i = 1; i < parts.length - 1; i += 1) {
        const parent = parts.slice(i).join('.');
        if (!parent) continue;
        variants.add(`${base}; domain=${parent}`);
        variants.add(`${base}; domain=.${parent}`);
      }
    }
  } catch (e) {}

  return Array.from(variants);
}

export function setGoogleTranslateLocale(locale) {
  const safeLocale = locale || 'en';
  const value = safeLocale === 'en' ? '' : `/en/${safeLocale}`;
  const variants = getGoogTransCookieVariants();

  variants.forEach((attrs) => {
    if (value) {
      document.cookie = `googtrans=${value}; ${attrs}; max-age=31536000`;
    } else {
      document.cookie = `googtrans=; ${attrs}; max-age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    }
  });
}

export function applyStoredLanguage() {
  try {
    const stored = localStorage.getItem('accountPreferences');
    if (stored) {
      const prefs = JSON.parse(stored);
      const lang = prefs.language || 'English';
      const locale = LANGUAGE_TO_LOCALE[lang] || 'en';
      document.documentElement.lang = locale;
    }
  } catch (e) {}
}

/**
 * Set Google Translate cookie and reload so the page is translated.
 * Call this when user clicks Apply in Account Preferences.
 * For English we clear the cookie so the page shows original text.
 * Cookie format: googtrans=/sourceLang/targetLang (e.g. /en/hi).
 */
export function applyTranslationAndReload() {
  try {
    const stored = localStorage.getItem('accountPreferences');
    const lang = stored ? (JSON.parse(stored).language || 'English') : 'English';
    const locale = LANGUAGE_TO_LOCALE[lang] || 'en';

    document.documentElement.lang = locale;
    setGoogleTranslateLocale(locale);

    // Short delay so cookie is written before reload (helps on some browsers)
    setTimeout(function () {
      window.location.reload();
    }, 100);
  } catch (e) {
    window.location.reload();
  }
}
